
namespace Matrix.Data {

	@Serenity.Decorators.registerClass()
	export class SecurityHoldingGrid extends AccountHoldingGrid {

		protected getInitialTitle() {
			return null;
		}

		protected getColumns() {
            return super.getColumns().filter(x =>
                x.field != AccountHoldingRow.Fields.InstanceCode &&
                x.field != AccountHoldingRow.Fields.SubAccountCode &&
                x.field != AccountHoldingRow.Fields.LotCount &&
                x.field != AccountHoldingRow.Fields.HoldingId);
		}

		protected getGridCanLoad() {
			return !!this._securityId;
		}

		private _securityId: number;

		public get securityId() {
			return this._securityId;
		}

		public set securityId(value: number) {
			if (this._securityId != value) {
				this._securityId = value;
				this.setEquality(AccountHoldingRow.Fields.SecurityId, value);
				this.refresh();
			}
		}
	}
}